<template>
  <section id="section-gold-card">
    <div
      id="gold-card"
      data-action="open_gold"
      data-listname="market_gold"
      data-assettype="gold"
      :data-assetname="dataAssetname"
      @click="openModal(goldType)"
    >
      <div class="gold-card-title">
        <div class="left">
          <span>{{ goldTitle }}</span>
          <span v-if="isGoldbar && type==='association'" class="price-change" :class="[priceChangeColor(change)]">
            <i :class="[isPriceChange(change)]"></i>
            {{ change | minusValue }}
          </span>
        </div>
        <div class="right">
          <i class="fas fa-chart-bar"></i>
        </div>
      </div>
      <div v-if="type==='association'" class="gold-card-content-association">
        <div class="left">
          <div class="title">รับซื้อ</div>
          <div class="content">
            <div class="price" :class="[priceColor(change)]">{{bid | currency}}</div>
            <div class="unit">฿</div>
          </div>
        </div>
        <div class="right">
          <div class="title">ขายออก</div>
          <div class="content">
            <div class="price" :class="[priceColor(change)]">{{ask | currency}}</div>
            <div class="unit">฿</div>
          </div>
        </div>
      </div>
      <div v-else class="gold-card-content-global">
        <div class="left">
          <div class="title">ราคาเปิด</div>
          <div class="content">
            <div class="price">{{bid | currency}}</div>
            <div class="unit">$</div>
          </div>
        </div>
        <div class="center">
          <div class="title">ราคาปิด</div>
          <div class="content">
            <div class="price">{{ask | currency}}</div>
            <div class="unit">$</div>
          </div>
        </div>
        <div class="right">
          <div class="title">% Chg.</div>
          <div class="content">
            <div class="price" :class="[priceChangeColor(change)]">{{change | percent}}</div>
          </div>
        </div>
      </div>
    </div>

    <modal-slide-up
      v-if="showModal"
      :options="{modalSize: 'tall'}"
      @close-modal="closeModal"
      class="modal"
      id="gold-modal"
      :padding="false"
      :isCloseOnClick="false"
    >
      <div id="modal-header" slot="header">{{ modalTitle }}</div>
      <div v-if="goldType == 'gold_spot'" id="modal-container" slot="body">
        <GoldPerformance :arrData="getGoldSpotHistoryGraph" />
        <GoldSpotGraphHistory
          :arrData="getGoldSpotHistoryGraph"
          gold-spot-id="gold-spot-history-graph-d3-line"
          :is-realtime="false"
          @call-tradingview="chartModalTV(goldType)"
        />
      </div>
      <div v-else id="modal-container" slot="body">
        <div id="goldtrader-container">
          <div class="goldtrader-left">
            <h2>{{ modalTitle }}</h2>
          </div>
          <div class="goldtrader-right">
            <FollowingGold followingType="GoldQuote" :item="{ ID: goldWatchlistName }" />
          </div>
          <div class="update-time">ราคาประจำวันที่: {{ currentDate}} | เวลา {{currentTime}} | ครั้งที่ {{currentRound}}</div>
          <div class="gold-bar">
            <div class="content-bar">
              <div class="content-col">
                <div class="left">
                  <div class="bid">รับซื้อ</div>
                  <span
                    v-if="isGoldbar && type==='association'"
                    class="price-change"
                    :class="[priceChangeColor(change)]"
                  >
                    <i :class="[isPriceChange(change)]"></i>
                    {{change | minusValue }}
                  </span>
                  <div class="content">
                    <div class="price" :class="[priceColor(change)]">{{bid | currency}}</div>
                    <div class="unit">฿</div>
                  </div>
                </div>
                <div class="right">
                  <div class="ask">ขายออก</div>
                  <span
                    v-if="isGoldbar && type==='association'"
                    class="price-change"
                    :class="[priceChangeColor(change)]"
                  >
                    <i :class="[isPriceChange(change)]"></i>
                    {{change | minusValue }}
                  </span>
                  <div class="content">
                    <div class="price" :class="[priceColor(change)]">{{ask | currency}}</div>
                    <div class="unit">฿</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="goldtrader-graph">
          <GoldGraphNav :id="goldType" @call-tradingview="chartModalTV(goldType)" />
        </div>
        <section>
          <gold-history-list :wantLoaing="true" :queryDate="queryDate" type="association" :isGoldbar="isGoldbar" />
        </section>
      </div>
    </modal-slide-up>
  </section>
</template>

<script>
import moment from "moment"
import { mapGetters, mapActions } from "vuex"
import GoldHistoryList from "./GoldHistoryList"
const ModalSlideUp = () => import("../global/ModalSlideUp")
const GoldGraphNav = () => import("../gold/GoldGraphNav")
import { FollowingGold } from "../../organisms/Following"

export default {
  components: {
    ModalSlideUp,
    GoldGraphNav,
    GoldHistoryList,
    GoldSpotGraphHistory: () => import("@/components/miniapp/gold/GoldSpotGraphHistory"),
    GoldPerformance: () => import("@/components/miniapp/gold/GoldPerformance"),
    FollowingGold
  },
  props: {
    type: {
      type: String,
      default: ""
    },
    goldType: {
      type: String,
      default: ""
    },
    goldTitle: {
      type: String,
      default: ""
    },
    modalTitle: {
      type: String,
      default: ""
    },
    change: {
      type: String,
      default: null
    },
    bid: {
      type: [String, Number],
      default: null
    },
    ask: {
      type: [String, Number],
      default: null
    },
    currentTime: {
      type: String,
      default: null
    },
    currentDate: {
      type: String,
      default: null
    },
    currentRound: {
      type: String,
      default: null
    },
    unitBaht: {
      type: String,
      default: "฿"
    },
    queryDate: {
      type: String,
      default: null
    },
    dataAssettype: {
      type: String,
      default: null
    },
    dataAssetname: {
      type: String,
      default: null
    },
    dataAction: {
      type: String,
      default: null
    },
    dataListname: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showModal: false,
      isGoldbar: true
    }
  },
  created() {
    if (this.goldType === "trader_bar") {
      this.isGoldbar = true
    } else {
      this.isGoldbar = false
    }
  },
  computed: {
    ...mapGetters("gold", ["getGoldSpotHistoryGraph"]),
    goldWatchlistName() {
      switch (this.goldType) {
        case "trader_bar":
          return "gold-trader-bar"
        case "trader_ornament":
          return "gold-trader-ornament"
        default:
          return "gold-trader-bar"
      }
    }
  },
  filters: {
    currency: function(val) {
      let toNumber = parseFloat(val)
      return toNumber
        .toLocaleString("th", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    percent: function(val) {
      if (val > 0) {
        return "+" + parseFloat(val) + " %"
      }

      return parseFloat(val).toFixed(1) + " %"
    },
    minusValue: function(val) {
      if (val < 0) {
        return parseFloat(val.replace("-", "")).toFixed(2)
      }

      return val
    },
    parseTime(date) {
      return moment.utc(date).format("HH.mm")
    },
    parseDate(date, format) {
      return moment(date)
        .locale("th")
        .add("543", "years")
        .format(format)
    }
  },
  methods: {
    ...mapActions("gold", ["findGoldTraderHistory", "clearGoldHistory"]),
    openModal(e) {
      this.showModal = true
      this.$router.replace({ query: { gold_detail: e, openModal: true} })
    },
    async closeModal() {
      this.showModal = false
      let query = Object.assign({}, this.$route.query)
      delete query.gold_detail
      delete query.openModal
      this.$router.replace({ query })
      await this.clearGoldHistory()
    },
    chartModalTV(short_code) {
      let gold_type = short_code == "gold_spot" ? "gold_spot" : "gold"
      this.$router.push({
        name: "miniapp-tradingview",
        query: { name: short_code, type: gold_type }
      })
    },
    isPriceChange(price) {
      if (price > 0) {
        return "fas fa-caret-up"
      } else if (price == 0) {
        return "fas fa-sort"
      } else return "fas fa-caret-down"
    },
    priceChangeColor(price) {
      if (price > 0) {
        return "plus"
      } else if (price == 0) {
        return "stable"
      } else return "minus"
    },
    priceColor(price) {
      if (price > 0 && this.isGoldbar) {
        return "plus"
      } else if (price < 0 && this.isGoldbar) {
        return "minus"
      } else return "content-stable"
    }
  }
}
</script>

<style lang="scss" scoped>
#gold-card {
  pointer-events: auto;
  cursor: pointer;
  margin-bottom: 12px;
  height: auto;
  background-color: $base-white;
  border-radius: 4px;
  border: solid 1px #efefef;
  box-shadow: 0 0 4px 0 rgba(228, 232, 234, 0.34);
  .gold-card-title {
    pointer-events: none;
    border-bottom: solid 1px #efefef;
    @extend %container-style;
    padding: 12px 16px;
    position: relative;
    .left {
      display: inline-block;
      @extend %font-size-s;
      font-weight: bold;
      color: $color-normal-text;
      text-align: left;
      @include finCol(8, 12, 0px, middle, true, true);
    }
    .right {
      @include finCol(4, 12, 0px, middle, true, true);
      display: inline-block;
      text-align: right;
      i {
        padding: 6px;
        color: $color-normal-text;
        background-color: $color-line-grey;
        border-radius: 4px;
        font-size: 12px;
      }
    }
  }
  .gold-card-content-association {
    pointer-events: none;
    @extend %container-style;
    padding: 8px 0px;
    position: relative;
    .left {
      display: inline-block;
      @include finCol(6, 12, 0px, middle, true, true);
      text-align: center;
    }
    &:after {
      content: "";
      margin-left: 0px;
      margin-top: 8px;
      position: absolute;
      left: 50%;
      width: 1px;
      background-color: rgba(186, 186, 186, 0.24);
      height: 45px;
    }
    .right {
      display: inline-block;
      @include finCol(6, 12, 0px, middle, true, true);
      text-align: center;
    }
    .title {
      @extend %font-size-ss;
      color: $color-secondary-text;
      display: inline-block;
    }
    .content {
      .price {
        @extend %font-size-l;
        display: inline-block;
      }
      .minus {
        color: $color-minus;
      }
      .plus {
        color: $color-plus;
      }
      .stable {
        color: $color-stable;
      }
      .content-stable {
        color: $color-normal-text;
      }
      .unit {
        padding-left: 3px;
        @extend %font-size-ss;
        color: $color-normal-text;
        display: inline-block;
      }
    }
  }
  .gold-card-content-global {
    pointer-events: none;
    @extend %container-style;
    padding: 8px 16px;
    position: relative;
    .left {
      display: inline-block;
      @include finCol(5, 12, 0px, middle, true, true);
    }
    .center {
      display: inline-block;
      @include finCol(4, 12, 0px, middle, true, true);
    }
    .right {
      display: inline-block;
      @include finCol(3, 12, 0px, middle, true, true);
      text-align: right;
    }
    .title {
      @extend %font-size-ss;
      color: $color-secondary-text;
      display: inline-block;
    }
    .content {
      .price {
        @extend %font-size-s;
        display: inline-block;
      }
      .minus {
        color: $color-minus;
      }
      .plus {
        color: $color-plus;
      }
      .stable {
        color: $color-stable;
      }
      .content-stable {
        color: $color-normal-text;
      }
      .unit {
        padding-left: 3px;
        @extend %font-size-ss;
        color: $color-normal-text;
        display: inline-block;
      }
    }
  }
  .price-change {
    pointer-events: none;
    @extend %font-size-ss;
    display: inline-block;
    color: $color-minus;
    margin-left: 3px;
    i {
      margin: 0 4px;
    }
  }
  .minus {
    color: $color-minus;
  }
  .plus {
    color: $color-plus;
  }
  .stable {
    color: $color-stable;
  }
  .content-stable {
    color: $color-normal-text;
  }
}
#gold-modal {
  color: $color-normal-text;

  h2 {
    @extend %font-size-m;
  }

  .update-time {
    font-family: DBHeaventRez;
    @extend %font-size-ss;
    color: $color-secondary;
    padding-bottom: 16px;
  }
  #modal-header {
    font-family: DBHeaventRez;
    @extend %font-size-s;
    width: 100%;
    text-align: center;
    font-weight: bold;
  }

  #modal-container {
    padding: 16px;
    .goldtrader-left {
      @include finCol(6, 12, 0px, middle, true, true);
    }
    .goldtrader-right {
      text-align: right;
      @include finCol(6, 12, 0px, middle, true, true);
    }
    .goldtrader-graph {
      margin: 24px auto;
      @extend %container-style;
      padding-left: 0;
      padding-right: 0;
      .graph-ctn {
        @include finCol(12, 12, 0px, middle, true, true);
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: flex;
      }
    }
  }
  .gold-bar {
    padding-bottom: 8px;
    .title-bar {
      border-radius: 4px;
      box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.24), 0 0 6px 0 rgba(228, 232, 234, 0);
      background-color: $base-white;
      .title-row {
        padding: 16px;
        .title {
          @extend %font-size-s;
          color: $color-normal-text;
          font-weight: bold;
          display: inline-block;
        }
        i {
          margin-left: 8px;
          color: $color-normal-text;
          font-size: 12px;
          font-weight: bold;
          display: inline-block;
        }
      }
    }

    .content-bar {
      border-radius: 4px;
      box-shadow: 0 0 4px 0 rgba(186, 186, 186, 0.24), 0 0 6px 0 rgba(228, 232, 234, 0);
      background-color: $base-white;

      .content-col {
        // width: 100%;
        padding-top: 8px;
        padding-bottom: 8px;
        // padding-left: 16px;

        .left {
          display: inline-block;
          // height: 70px;
          text-align: center;
          @include finCol(6, 12, 0px, middle, true, true);
          border-right: 1px solid rgba(186, 186, 186, 0.11);
          .bid {
            @extend %font-size-ss;
            color: $color-secondary-text;
            display: inline-block;
          }

          .change {
            @extend %font-size-ss;
            display: inline-block;
            color: $color-minus;
            margin-left: 3px;
          }
          .price-change {
            @extend %font-size-ss;
            display: inline-block;
            color: $color-minus;
            margin-left: 3px;
            i {
              margin: 0 4px;
            }
          }
          .minus {
            color: $color-minus;
          }
          .plus {
            color: $color-plus;
          }
          .stable {
            color: $color-stable;
          }
          .content {
            .price {
              @extend %font-size-l;
              display: inline-block;
            }
            .unit {
              padding-left: 3px;
              @extend %font-size-ss;
              color: $color-normal-text;
              display: inline-block;
            }
          }
        }

        .right {
          padding-right: 16px;
          display: inline-block;
          // height: 70px;
          text-align: center;
          @include finCol(6, 12, 0px, middle, true, true);
          .ask {
            @extend %font-size-ss;
            color: $color-secondary-text;
            display: inline-block;
          }
          .change {
            @extend %font-size-ss;
            display: inline-block;
            color: $color-minus;
            margin-left: 3px;
          }
          .price-change {
            @extend %font-size-ss;
            display: inline-block;
            color: $color-minus;
            margin-left: 3px;
            i {
              margin: 0 4px;
            }
          }
          .minus {
            color: $color-minus;
          }
          .plus {
            color: $color-plus;
          }
          .stable {
            color: $color-stable;
          }
          .content {
            .price {
              @extend %font-size-l;
              display: inline-block;
            }
            .unit {
              padding-left: 3px;
              @extend %font-size-ss;
              color: $color-normal-text;
              display: inline-block;
            }
          }
        }
      }
    }
  }
}
</style>